import { Component, OnInit } from '@angular/core';
import { NbDialogRef, NbGlobalLogicalPosition, NbToastrService } from '@nebular/theme';
import { CadastroUsuarioDataService } from '../../../../../pages/cadastro/shared/services/CadastroUsuarioController/cadastroUsuario-data.service';
import { UsuarioSignature } from '../../../../../pages/cadastro/shared/models/signature/UsuarioSignature';
import { AtualizaNovaSenhaSignature } from '../../../../../pages/cadastro/shared/models/signature/AtualizaNovaSenhaSignature';

@Component({
  selector: 'ngx-custom-popup-trocar-senha',
  templateUrl: './custom-popup-trocar-senha.component.html',
  styleUrls: ['./custom-popup-trocar-senha.component.scss']
})
export class CustomPopupTrocarSenhaComponent implements OnInit {
  logicalPositions = NbGlobalLogicalPosition;
  hide = true;
  hide2 = true;

  senha: string = '';
  confirmarSenha: string = '';
  constructor(public dialogRef: NbDialogRef<CustomPopupTrocarSenhaComponent>,
    private cadastroUsuarioService: CadastroUsuarioDataService,
    private toastrService: NbToastrService,
  ) { }

  ngOnInit() {
  }

  trocarSenha() {
    if (!this.bloquearBotaoAlterarSenha()){ 
      let novaSenha: AtualizaNovaSenhaSignature = new AtualizaNovaSenhaSignature({
        novoPassword: this.senha
      });
      
      this.cadastroUsuarioService.UpdateNovaSenha(novaSenha).subscribe(
        value => {
          this.toastrService.success("Senha atualziada com sucesso", 'Sucesso' , { position: this.logicalPositions.TOP_END });
          this.close();
        },
        err => {
          this.toastrService.danger(err.error.Message, 'Erro ao Atualizar a senha' , { position: this.logicalPositions.TOP_END });
        });
    }    
  }
  
  close() {
    this.dialogRef.close();
  }
  
  onFocus(event: FocusEvent): void {
      (event.target as HTMLElement).blur(); // Remove o foco do botão
  }

  bloquearBotaoAlterarSenha(): boolean {
    const temMaiuscula = /[A-Z]/.test(this.senha) && /[A-Z]/.test(this.confirmarSenha);
    const temMinuscula = /[a-z]/.test(this.senha) && /[a-z]/.test(this.confirmarSenha);
    const temSimbolo = /[^A-Za-z0-9]/.test(this.senha) && /[^A-Za-z0-9]/.test(this.confirmarSenha);
    const tamanhoValido = this.senha.length >= 8 && this.confirmarSenha.length >= 8;
    const senhasIguais = this.senha === this.confirmarSenha;

    return !(temMaiuscula && temMinuscula && temSimbolo && tamanhoValido && senhasIguais);
  }
}
